/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {LabelTypographyVariantEnum} from '../../types/types';
import {LabelTypography} from '../../typography/LabelTypography';

interface ContentLabelProps {
  label: string;
  isLightColor?: boolean;
  variantType?: keyof typeof LabelTypographyVariantEnum;
  styles?: {
    [key: string]: string;
  }
}

/**
 * Reusable component for displaying simple content usually in the content of a
 * card to provide consistent styling for content typography
 *
 * ```typescript
 *   <ContentLabel label='Label'
 *     isLightColor
 *     styles={{color: dlsColor('grey3')}} />
 *
 * ```
 */
const ContentLabel = ({
  label,
  isLightColor = false,
  variantType = 'label2',
  styles = {}
}: ContentLabelProps) => (
  <LabelTypography variantType={variantType} style={{
    ...(isLightColor && {color: dlsColor('grey3')}),
    ...styles
  }}>
    {label}
  </LabelTypography>
);

export default ContentLabel;
